<template>
	<div
		class="d-flex justify-center align-center py-16"
		v-if="loading">
		<v-progress-circular
			indeterminate
			color="primary"></v-progress-circular>
	</div>
	<div
		v-else
		class="messages d-flex flex-column-reverse align-center"
	>
		<v-dialog
			v-model="previewDialog"
			max-width="400"
		>
			<v-card max-width="400">
				<v-card-text class="pa-3">
					<v-img
						:src="imagePreview"
						max-height="400"
						max-width="400"
						contain
						class="rounded mx-auto"
					/>
				</v-card-text>
				<v-card-actions class="justify-center pt-0">
					<v-btn @click="previewDialog = false">
						إغلاق
					</v-btn>
					<v-btn
						color="primary"
						@click="sendMessage(); previewDialog = false;"
					>
						إرسال
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<div style="width: 100%">
			<div class="d-flex flex-column">
				<div
					dense
					color="transparent"
					class="d-flex flex-column">
					<div
						v-for="(message, i) in messages"
						:key="i"
						class="px-0 mb-2"
					>
						<message :message="message"/>
					</div>
				</div>
				<div
					height="150"
					class="px-2 white text-area message-input">
					<p
						v-if="$isOffline.value"
						class="white darken-1 font-weight-bold mb-0 pa-2 text--secondary">
						لا يمكن ارسال بدون اتصال بالانترنت
					</p>
					<div
						class="d-flex pt-2"
						style="width: 100%">
						<div class="ml-2 flex-grow-1">
							<v-textarea
								v-model="message"
								label="الرسالة"
								outlined
								dense
								hide-details
								auto-grow
								:rows="2"
								class="rounded-lg"
							>
								<template v-if="useUploadChatImage" v-slot:append>
									<v-file-input
										v-model="image"
										class="image-input"
										dense
										hide-input
										:prepend-icon="image ? 'mdi-image' : 'mdi-image-outline'"
										accept="image/*"
										@change="showPreview"
									/>
								</template>
							</v-textarea>
							<v-checkbox
								:disabled="$isOffline.value"
								dense
								hide-details=""
								label="مرسل من قبل ولي الأمر"
								v-model="isParent"></v-checkbox>
						</div>
						<div>
							<v-btn
								:disabled="$isOffline.value"
								@click="sendMessage"
								class="py-4"
								color="primary">
								<v-icon class="send-icon text-h5"> mdi-send-variant </v-icon>
							</v-btn>
						</div>
					</div>

					<p class="my-2 px-2">يتم الرد على الرسائل خلال يومي عمل ضمن أوقات الدوام الرسمي</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Message from '@/components/Message.vue';
import { mapState } from 'vuex';
import config from '@/helpers/config';

export default {
	name: 'Chat',
	components: { Message },
	data() {
		return {
			message: null,
			image: null,
			isParent: false,

			previewDialog: false,
			imagePreview: null,

			sent: false,
			loading: true,
			useUploadChatImage: config.useUploadChatImage
		};
	},

	watch: {
		previewDialog(val) {
			if (!val) {
				this.image = null;
				this.imagePreview = null;
			}
		}
	},

	computed: {
		...mapState({
			messages: (state) => state.messages.messages,
		}),
	},

	methods: {
		sendMessage() {
			if (this.message || this.image) {
				this.$store.dispatch('messages/sendMessage', {
					message: this.message,
					image: this.image,
					isParent: this.isParent,
				}).then(() => {
					this.$eventBus.$emit('show-snackbar', false, 'تم إرسال رسالتك');
					this.sent = true;
					this.message = null;
					this.fetch();
				});
			}
		},
		fetch() {
			this.loading = true;
			this.$store.dispatch('messages/fetchAll').finally(() => {
				this.loading = false;
			});
		},

		showPreview() {
			if (this.image) {
				this.imagePreview = URL.createObjectURL(this.image);
				this.previewDialog = true;
			}
		}
	},
	mounted() {
		this.fetch();
	},
};
</script>

<style lang="scss" scoped>
.send-icon {
	transform: scale(-1);
}
.messages {
	padding-top: 10px;
	height: calc(100vh - 60px);
	overflow-y: scroll;
}
.message-input {
	position: sticky;
	bottom: 0;
}
</style>
<style lang="scss">
.image-input {
	.v-input__prepend-outer {
		margin: 0 !important;
	}
}
</style>
